import { id } from "./id";
import { state } from "./state";

export const getters = defineStoreGetters({ id, state }, {});
